"use strict";
// timeout using a promise, for use with async/await
Object.defineProperty(exports, "__esModule", { value: true });
function delay(wait = 250) {
    return new Promise((resolve) => {
        setTimeout(() => resolve(undefined), wait);
    });
}
exports.default = delay;
